class Quantity {
    static targetSelector = 'input[data-price-quantity]';
    static pageRoute = 'route';
    static targetPageRoute = 'product/product';

    /**
     * @param {number} defaultValue
     * @return {number|number|number}
     */
    static get(defaultValue = 1) {
        const inputRoute = document.getElementById(Quantity.pageRoute);

        if (inputRoute && inputRoute.value === Quantity.targetPageRoute) {
            const item = document.querySelector(Quantity.targetSelector);

            if (!item) {
                return defaultValue;
            }

            const itemQuantity = parseInt(item.value, 10);

            return itemQuantity ?? defaultValue;
        }

        return defaultValue;
    }
}

export default Quantity;
